import { FC } from 'react';
import { Link } from 'react-router-dom';

import fadedFlowerImg from 'assets/brand/faded-flower.png';
import Button from 'components/_core/Button';
import Text from 'components/_core/Text';
import BackButton from 'components/BackButton';
import DecorativeImage from 'components/DecorativeImage';
import HelpSection from 'components/HelpSection';

import ButtonRow from '../components/ButtonRow';
import Title from '../components/Title';
import locales from './locales';
import { ClickHereLink } from './styles';

const Confirmation: FC = () => (
  <>
    <BackButton marginBottom="space-24" />

    <DecorativeImage src={fadedFlowerImg} />
    <Title>{locales.title}</Title>
    <Text size="sm">{locales.body}</Text>
    <ButtonRow>
      <Button as={Link} to="/" variant="inline-secondary">
        {locales.keepMyAccount}
      </Button>
      <Button
        as={Link}
        to="/company/account-closure/confirmation-code"
        variant="danger"
      >
        {locales.closeMyAccount}
      </Button>
    </ButtonRow>

    <HelpSection>
      {locales.help}
      <a
        href="https://www.shine.fr/blog/cesser-activite-auto-entrepreneur-profession-liberale/"
        rel="noopener noreferrer"
        target="_blank"
      >
        <ClickHereLink>{locales.clickHere}</ClickHereLink>
      </a>
    </HelpSection>
  </>
);

export default Confirmation;
